import React, { useEffect, useState } from "react";
import { Modal } from "antd-mobile";
import { useHistory } from "react-router-dom";

const QlAlert = ()=> {

  const history = useHistory()

  const [visible, setVisible] = useState(false)

  const handleCancel = ()=> {
    history.replace('/login');
    window.location.reload();
  }

  const handleConfirm = ()=> {
    sessionStorage.qlAlert = true
    setVisible(false)
  }

  useEffect(()=> {
    if (['TENANT-067', 'TENANT-0201'].includes(localStorage.tenantCode)) {
      setVisible(true)
    }
  }, [])

  if (sessionStorage.qlAlert) {
    return null
  }

  return (
    <Modal
      transparent
      visible={visible}
      maskClosable={false}
      title="提示"
      style={{ width: '90%' }}
      footer={[
        { text: '取消', onPress: handleCancel },
        { text: '确定', onPress: handleConfirm }
      ]}
    >
      当前录入数据的时间已超出临床协议约定日期，若产生任何法律风险，由研究中心自行承担。
    </Modal>
  )
}

export default QlAlert
